var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _defs, _g22, _g23, _g24, _defs2, _g25, _defs3, _g26, _defs4, _g27, _defs5, _g28, _defs6, _g29, _defs7, _g30, _animate, _animate2, _animate3, _animate4, _animate5, _animate6, _animate7, _animate8, _animate9, _animate10, _animate11, _animate12, _animate13, _animate14, _animate15, _animate16, _animate17, _animate18, _animate19, _animate20, _animate21, _animate22, _animate23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m6exy5kr77104676",
    viewBox: "0 0 420 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kr77104676_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kr77104676",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5kt08803536_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kt08803536_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kt08803536",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5kt08803536_fill_path",
    d: "M0.01,0h419.98c0.00552,0 0.01,0.00448 0.01,0.01v249.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-419.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-249.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fillRule: "nonzero",
    fill: "rgb(255, 218, 187)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m6exy5kt08803536_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kw95797049_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-146.4804,-190.9354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kw95797049",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kw30751218_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,44.4677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kw30751218",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kx62412810_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4618,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5kx62412810",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5kx62412810_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5kx62412810_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5kx62412810ps0)",
    mask: "url(#m6exy5kx62412810_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ky21451295_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,317.0859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ky21451295",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5ky21451295_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5ky21451295_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5ky21451295ps0)",
    mask: "url(#m6exy5ky21451295_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l002518671_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,196.9657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l002518671",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l002518671_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l002518671_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5l002518671ps0)",
    mask: "url(#m6exy5l002518671_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l128711020_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,248.9579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l128711020",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l128711020_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l128711020_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5l128711020ps0)",
    mask: "url(#m6exy5l128711020_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l282458567_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,66.7032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l282458567",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l282458567_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l282458567_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5l282458567ps0)",
    mask: "url(#m6exy5l282458567_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l322747780_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.457,376.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l322747780",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l322747780_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l322747780_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5l322747780ps0)",
    mask: "url(#m6exy5l322747780_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l492810108_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,137.8496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l492810108",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l492810108_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l492810108_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5l492810108ps0)",
    mask: "url(#m6exy5l492810108_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l545332138_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4589,409.1015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l545332138",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l545332138_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l545332138_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6exy5l545332138ps0)",
    mask: "url(#m6exy5l545332138_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l703706771_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,92.6797,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l703706771",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l735651780_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l735651780",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l735651780_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l735651780_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6exy5l735651780ps0)",
    mask: "url(#m6exy5l735651780_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l812999239_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l812999239",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l812999239_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l812999239_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6exy5l812999239ps0)",
    mask: "url(#m6exy5l812999239_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l920502304_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5l920502304",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5l920502304_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5l920502304_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6exy5l920502304ps0)",
    mask: "url(#m6exy5l920502304_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5la52895185_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,268.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5la52895185",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5la52895185_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5la52895185_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6exy5la52895185ps0)",
    mask: "url(#m6exy5la52895185_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lb04914461_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,349.6005,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lb04914461",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lb04914461_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lb04914461_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6exy5lb04914461ps0)",
    mask: "url(#m6exy5lb04914461_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lc84775688_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,106.4032,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lc84775688",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lc84775688_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lc84775688_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6exy5lc84775688ps0)",
    mask: "url(#m6exy5lc84775688_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ld03792250_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,525.1611,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ld03792250",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5ld03792250_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(161, 199, 255)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5ld03792250_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6exy5ld03792250ps0)",
    mask: "url(#m6exy5ld03792250_gradient_mask)"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5le53578409_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52.7998,102.4903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5le53578409",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5le53578409_stroke_path",
    d: "M0,67.8287c0,0 0,-48.7086 0,-51.0287c0,-2.3201 0.3915,-4.2857 1.2785,-6.4294c0.887,-2.1437 2.0008,-3.8085 3.6422,-5.4499c1.6414,-1.6414 3.3062,-2.7552 5.4499,-3.6422c2.1437,-0.887 4.1093,-1.2785 6.4294,-1.2785c2.3201,0 145.4002,0 145.4002,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5le53578409_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -163.40019999999998,
    y: -69.0287,
    width: 490.20059999999995,
    height: 207.0861,
    fill: "url(#m6exy5le53578409ps0)",
    mask: "url(#m6exy5le53578409_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lg42996160_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,133.7998,102.4903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lg42996160",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lg42996160_stroke_path",
    d: "M0,68.1275c0,0 0,-49.0074 0,-51.3275c0,-2.3201 0.3915,-4.2857 1.2785,-6.4294c0.887,-2.1437 2.0008,-3.8085 3.6422,-5.4499c1.6414,-1.6414 3.3062,-2.7552 5.4499,-3.6422c2.1437,-0.887 4.1093,-1.2785 6.4294,-1.2785c2.3201,0 44.4,0 44.4,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lg42996160_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -62.400000000000006,
    y: -69.3275,
    width: 187.20000000000002,
    height: 207.98250000000002,
    fill: "url(#m6exy5lg42996160ps0)",
    mask: "url(#m6exy5lg42996160_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lg84208070_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,214.7998,103.0879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lg84208070",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lg84208070_stroke_path",
    d: "M0,66.9323v-66.9323",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lg84208070_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.2,
    y: -68.1323,
    width: 3.5999999999999996,
    height: 204.39690000000002,
    fill: "url(#m6exy5lg84208070ps0)",
    mask: "url(#m6exy5lg84208070_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lh74006792_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246467991473532e-16,1.2245243344674385e-16,0.9999,214.7998,76.1953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lh74006792",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lh74006792_stroke_path",
    d: "M0,37.6494v-37.6494",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lh74006792_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.2,
    y: -38.8494,
    width: 3.5999999999999996,
    height: 116.54820000000001,
    fill: "url(#m6exy5lh74006792ps0)",
    mask: "url(#m6exy5lh74006792_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5li76896372_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9999999999984769,-0.0000017453292519115186,-0.0000017451547189863274,0.999899999998477,376.7998,102.4903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5li76896372",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5li76896372_stroke_path",
    d: "M0,68.1275c0,0 0,-49.0074 0,-51.3275c0,-2.3201 0.3915,-4.2857 1.2785,-6.4294c0.887,-2.1437 2.0008,-3.8085 3.6422,-5.4499c1.6414,-1.6414 3.3062,-2.7552 5.4499,-3.6422c2.1437,-0.887 4.1093,-1.2785 6.4294,-1.2785c2.3201,0 144.9998,0 144.9998,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5li76896372_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -162.9998,
    y: -69.3275,
    width: 488.9994,
    height: 207.98250000000002,
    fill: "url(#m6exy5li76896372ps0)",
    mask: "url(#m6exy5li76896372_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5li62600757_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9999999999984769,-0.0000017453292519115186,-0.0000017451547189863274,0.999899999998477,295.7998,102.4903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5li62600757",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5li62600757_stroke_path",
    d: "M0,68.1275c0,0 0,-49.0074 0,-51.3275c0,-2.3201 0.3915,-4.2857 1.2785,-6.4294c0.887,-2.1437 2.0008,-3.8085 3.6422,-5.4499c1.6414,-1.6414 3.3062,-2.7552 5.4499,-3.6422c2.1437,-0.887 4.1093,-1.2785 6.4294,-1.2785c2.3201,0 44.4,0 44.4,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5li62600757_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -62.400000000000006,
    y: -69.3275,
    width: 187.20000000000002,
    height: 207.98250000000002,
    fill: "url(#m6exy5li62600757ps0)",
    mask: "url(#m6exy5li62600757_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lj99536804_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.3994,165.2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lj99536804",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lj99536804_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lk65753014_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.3994,165.2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lk65753014",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lk65753014_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ll85799611_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,371.3994,165.2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ll85799611",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5ll85799611_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ll03534236_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,290.3994,165.2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ll03534236",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5ll03534236_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lm32914327_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.3994,165.2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lm32914327",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lm32914327_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lm18604400_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,199.5,48.107200000000006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lm18604400",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lm18604400_fill_path",
    d: "M15.26335,0h0.0733c8.42972,0 15.26335,6.83363 15.26335,15.26335v0c0,8.42972 -6.83363,15.26335 -15.26335,15.26335h-0.0733c-8.42972,0 -15.26335,-6.83363 -15.26335,-15.26335v0c0,-8.42972 6.83363,-15.26335 15.26335,-15.26335z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ln99103134_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.1857,2.1491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5ln99103134",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6exy5ln99103134_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5ln99103134_fill_path",
    d: "M0.01,0h26.2086c0.00552,0 0.01,0.00448 0.01,0.01v26.2086c0,0.00552 -0.00448,0.01 -0.01,0.01h-26.2086c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-26.2086c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6exy5ln99103134_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy6zl46507986_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy6zl46507986",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy6zm04271248_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.2906,3.2906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy6zm04271248",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy6zm04271248_stroke_path",
    d: "M2.17341,4.5777c0,-0.63766 0.25331,-1.2492 0.7042,-1.70009c0.45089,-0.45089 1.06243,-0.7042 1.70009,-0.7042h1.09286c0.63484,-0.00036 1.24377,-0.25179 1.69393,-0.69943l0.765,-0.765c0.22343,-0.22469 0.48908,-0.403 0.78166,-0.52467c0.29258,-0.12167 0.60633,-0.18431 0.9232,-0.18431c0.31687,0 0.63062,0.06264 0.9232,0.18431c0.29258,0.12167 0.55823,0.29998 0.78166,0.52467l0.765,0.765c0.45026,0.44807 1.06007,0.69943 1.69393,0.69943h1.09286c0.63766,0 1.2492,0.25331 1.70009,0.7042c0.45089,0.45089 0.7042,1.06243 0.7042,1.70009v1.09286c0,0.63386 0.25136,1.24367 0.69943,1.69393l0.765,0.765c0.22469,0.22343 0.403,0.48908 0.52467,0.78166c0.12167,0.29258 0.18431,0.60633 0.18431,0.9232c0,0.31687 -0.06264,0.63062 -0.18431,0.9232c-0.12167,0.29258 -0.29998,0.55823 -0.52467,0.78166l-0.765,0.765c-0.44764,0.45016 -0.69906,1.05909 -0.69943,1.69393v1.09286c0,0.63766 -0.25331,1.2492 -0.7042,1.70009c-0.45089,0.45089 -1.06243,0.7042 -1.70009,0.7042h-1.09286c-0.63484,0.00036 -1.24377,0.25179 -1.69393,0.69943l-0.765,0.765c-0.22343,0.22469 -0.48908,0.403 -0.78166,0.52467c-0.29258,0.12167 -0.60633,0.18431 -0.9232,0.18431c-0.31687,0 -0.63062,-0.06264 -0.9232,-0.18431c-0.29258,-0.12167 -0.55823,-0.29998 -0.78166,-0.52467l-0.765,-0.765c-0.45016,-0.44764 -1.05909,-0.69906 -1.69393,-0.69943h-1.09286c-0.63766,0 -1.2492,-0.25331 -1.70009,-0.7042c-0.45089,-0.45089 -0.7042,-1.06243 -0.7042,-1.70009v-1.09286c-0.00036,-0.63484 -0.25179,-1.24377 -0.69943,-1.69393l-0.765,-0.765c-0.22469,-0.22343 -0.403,-0.48908 -0.52467,-0.78166c-0.12167,-0.29258 -0.18431,-0.60633 -0.18431,-0.9232c0,-0.31687 0.06264,-0.63062 0.18431,-0.9232c0.12167,-0.29258 0.29998,-0.55823 0.52467,-0.78166l0.765,-0.765c0.44764,-0.45016 0.69907,-1.05909 0.69943,-1.69393z",
    fill: "none",
    stroke: "rgb(3, 105, 255)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy6zm04271248_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -23.268700000000003,
    y: -23.268700000000003,
    width: 69.80610000000001,
    height: 69.80610000000001,
    fill: "url(#m6exy6zm04271248ps0)",
    mask: "url(#m6exy6zm04271248_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy6zo74875768_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.832,10.9283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy6zo74875768",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy6zo74875768_stroke_path",
    d: "M0,2.18571l2.18571,2.18571l4.37143,-4.37143",
    fill: "none",
    stroke: "rgb(3, 105, 255)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy6zo74875768_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.9,0c0,-0.49706 0.40294,-0.9 0.9,-0.9c0.49706,0 0.9,0.40294 0.9,0.9c0,0.49706 -0.40294,0.9 -0.9,0.9c-0.49706,0 -0.9,-0.40294 -0.9,-0.9z",
    transform: "matrix(-0.7071067811865477,-0.7071067811865475,0.7071067811865475,-0.7071067811865477,0,2.18571)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.9,0c0,-0.49706 0.40294,-0.9 0.9,-0.9c0.49706,0 0.9,0.40294 0.9,0.9c0,0.49706 -0.40294,0.9 -0.9,0.9c-0.49706,0 -0.9,-0.40294 -0.9,-0.9z",
    transform: "matrix(0.7071067811865476,-0.7071067811865475,0.7071067811865475,0.7071067811865476,6.55714,-0.000010000000000509601)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -10.1571,
    y: -7.971400000000001,
    width: 30.4713,
    height: 23.9142,
    fill: "url(#m6exy6zo74875768ps0)",
    mask: "url(#m6exy6zo74875768_gradient_mask)"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lq88522959_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.5996,180.7773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lq88522959",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lq88522959_fill_path",
    d: "M12.3703,0h74.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-74.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6exy5lq88522959_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lq88522959_stroke_path",
    d: "M12.3703,0h74.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-74.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6exy5lq88522959_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lq88522959_stroke_path",
    d: "M12.3703,0h74.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-74.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(162, 197, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lq88522959_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -99.39999999999999,
    y: -25.340600000000002,
    width: 298.2,
    height: 76.02180000000001,
    fill: "url(#m6exy5lq88522959ps0)",
    mask: "url(#m6exy5lq88522959_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lq43201244_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lq43201244",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lq43201244_fill_path",
    d: "M3.04006,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM8.89006,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.25124,0.1696 1.68004,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.47844c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.06564,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.35844,0.1792 -0.78404,0.2688 -1.27684,0.2688zM13.7705,8.9344h2.208v1.0656h-3.552v-6.7008h1.344zM18.7938,6.64c0,-0.6592 0.1472,-1.248 0.4416,-1.7664c0.3008,-0.5248 0.7072,-0.9312 1.2192,-1.2192c0.5184,-0.2944 1.0976,-0.4416 1.7376,-0.4416c0.7488,0 1.4048,0.192 1.968,0.576c0.5632,0.384 0.9568,0.9152 1.1808,1.5936h-1.5456c-0.1536,-0.32 -0.3712,-0.56 -0.6528,-0.72c-0.2752,-0.16 -0.5952,-0.24 -0.96,-0.24c-0.3904,0 -0.7392,0.0928 -1.0464,0.2784c-0.3008,0.1792 -0.5376,0.4352 -0.7104,0.768c-0.1664,0.3328 -0.2496,0.7232 -0.2496,1.1712c0,0.4416 0.0832,0.832 0.2496,1.1712c0.1728,0.3328 0.4096,0.592 0.7104,0.7776c0.3072,0.1792 0.656,0.2688 1.0464,0.2688c0.3648,0 0.6848,-0.08 0.96,-0.24c0.2816,-0.1664 0.4992,-0.4096 0.6528,-0.7296h1.5456c-0.224,0.6848 -0.6176,1.2192 -1.1808,1.6032c-0.5568,0.3776 -1.2128,0.5664 -1.968,0.5664c-0.64,0 -1.2192,-0.144 -1.7376,-0.432c-0.512,-0.2944 -0.9184,-0.7008 -1.2192,-1.2192c-0.2944,-0.5184 -0.4416,-1.1072 -0.4416,-1.7664zM31.433,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM30.041,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM33.758,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM37.86,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM40.6987,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM41.3611,4.6816v5.3184h-1.344v-5.3184zM45.1274,5.7856h-0.9312v4.2144h-1.3632v-4.2144h-0.6048v-1.104h0.6048v-0.2688c0,-0.6528 0.1856,-1.1328 0.5568,-1.44c0.3712,-0.3072 0.9312,-0.4512 1.68,-0.432v1.1328c-0.3264,-0.0064 -0.5536,0.048 -0.6816,0.1632c-0.128,0.1152 -0.192,0.3232 -0.192,0.624v0.2208h0.9312zM46.6799,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM47.3423,4.6816v5.3184h-1.344v-5.3184zM48.3246,7.3408c0,-0.5504 0.112,-1.0304 0.336,-1.44c0.224,-0.416 0.5344,-0.736 0.9312,-0.96c0.3968,-0.2304 0.8512,-0.3456 1.3632,-0.3456c0.6592,0 1.2032,0.1664 1.632,0.4992c0.4352,0.3264 0.7264,0.7872 0.8736,1.3824h-1.4496c-0.0768,-0.2304 -0.208,-0.4096 -0.3936,-0.5376c-0.1792,-0.1344 -0.4032,-0.2016 -0.672,-0.2016c-0.384,0 -0.688,0.1408 -0.912,0.4224c-0.224,0.2752 -0.336,0.6688 -0.336,1.1808c0,0.5056 0.112,0.8992 0.336,1.1808c0.224,0.2752 0.528,0.4128 0.912,0.4128c0.544,0 0.8992,-0.2432 1.0656,-0.7296h1.4496c-0.1472,0.576 -0.4384,1.0336 -0.8736,1.3728c-0.4352,0.3392 -0.9792,0.5088 -1.632,0.5088c-0.512,0 -0.9664,-0.112 -1.3632,-0.336c-0.3968,-0.2304 -0.7072,-0.5504 -0.9312,-0.96c-0.224,-0.416 -0.336,-0.8992 -0.336,-1.4496zM54.0996,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM58.2852,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM62.5163,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM69.6173,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM68.2253,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lv95816789_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,177.5996,180.7773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lv95816789",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lv95816789_fill_path",
    d: "M12.3703,0h55.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-55.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6exy5lv95816789_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lv95816789_stroke_path",
    d: "M12.3703,0h55.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-55.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6exy5lv95816789_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lv95816789_stroke_path",
    d: "M12.3703,0h55.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-55.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(162, 197, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lv95816789_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -80.39999999999999,
    y: -25.340600000000002,
    width: 241.2,
    height: 76.02180000000001,
    fill: "url(#m6exy5lv95816789ps0)",
    mask: "url(#m6exy5lv95816789_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lv70389149_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lv70389149",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lv70389149_fill_path",
    d: "M2.21265,3.2992v6.7008h-1.344v-6.7008zM8.42692,5.3728c0,0.3584 -0.0864,0.6944 -0.2592,1.008c-0.1664,0.3136 -0.432,0.5664 -0.7968,0.7584c-0.3584,0.192 -0.8128,0.288 -1.3632,0.288h-1.1232v2.5728h-1.344v-6.7008h2.4672c0.5184,0 0.96,0.0896 1.3248,0.2688c0.3648,0.1792 0.6368,0.4256 0.816,0.7392c0.1856,0.3136 0.2784,0.6688 0.2784,1.0656zM5.95012,6.3424c0.3712,0 0.6464,-0.0832 0.8256,-0.2496c0.1792,-0.1728 0.2688,-0.4128 0.2688,-0.72c0,-0.6528 -0.3648,-0.9792 -1.0944,-0.9792h-1.0656v1.9488zM11.323,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2385,-0.336c0.3968,0 0.7423,0.08 1.0367,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM15.5086,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.1279,-0.2368 -0.3007,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7007,-0.192c-0.2497,0 -0.4801,0.0608 -0.6913,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6913,0.192c0.2495,0 0.4831,-0.0608 0.7007,-0.1824c0.2177,-0.128 0.3905,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM17.8293,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM22.0149,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM24.3356,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM28.5212,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM32.5314,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM40.0126,7.2256c0,0.192 -0.0127,0.3648 -0.0383,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4031,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4993,0 0.8544,-0.2144 1.0656,-0.6432h1.4497c-0.1536,0.512 -0.448,0.9344 -0.8833,1.2672c-0.4352,0.3264 -0.9695,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4031,-0.2304 -0.7199,-0.5536 -0.9503,-0.9696c-0.2241,-0.416 -0.3361,-0.896 -0.3361,-1.44c0,-0.5504 0.112,-1.0336 0.3361,-1.4496c0.224,-0.416 0.5375,-0.736 0.9408,-0.96c0.4031,-0.224 0.8672,-0.336 1.3919,-0.336c0.5056,0 0.9569,0.1088 1.3536,0.3264c0.4033,0.2176 0.7136,0.528 0.9313,0.9312c0.224,0.3968 0.3359,0.8544 0.3359,1.3728zM38.6207,6.8416c-0.0064,-0.3456 -0.1313,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3329,0 -0.6144,0.1024 -0.8448,0.3072c-0.2241,0.1984 -0.3617,0.4768 -0.4128,0.8352zM43.0289,10.0864c-0.4352,0 -0.8256,-0.0768 -1.1712,-0.2304c-0.3456,-0.16 -0.6208,-0.3744 -0.8256,-0.6432c-0.1985,-0.2688 -0.3073,-0.5664 -0.3264,-0.8928h1.3535c0.0257,0.2048 0.1248,0.3744 0.2976,0.5088c0.1792,0.1344 0.4001,0.2016 0.6624,0.2016c0.256,0 0.4544,-0.0512 0.5952,-0.1536c0.1473,-0.1024 0.2209,-0.2336 0.2209,-0.3936c0,-0.1728 -0.0896,-0.3008 -0.2689,-0.384c-0.1727,-0.0896 -0.4512,-0.1856 -0.8351,-0.288c-0.3969,-0.096 -0.7233,-0.1952 -0.9793,-0.2976c-0.2496,-0.1024 -0.4671,-0.2592 -0.6527,-0.4704c-0.1793,-0.2112 -0.2689,-0.496 -0.2689,-0.8544c0,-0.2944 0.0833,-0.5632 0.2496,-0.8064c0.1728,-0.2432 0.416,-0.4352 0.7297,-0.576c0.32,-0.1408 0.6944,-0.2112 1.1231,-0.2112c0.6336,0 1.1392,0.16 1.5168,0.48c0.3777,0.3136 0.5856,0.7392 0.6241,1.2768h-1.2864c-0.0192,-0.2112 -0.1089,-0.3776 -0.2689,-0.4992c-0.1536,-0.128 -0.3616,-0.192 -0.6239,-0.192c-0.2433,0 -0.4321,0.0448 -0.5665,0.1344c-0.1279,0.0896 -0.1919,0.2144 -0.1919,0.3744c0,0.1792 0.0896,0.3168 0.2688,0.4128c0.1791,0.0896 0.4575,0.1824 0.8352,0.2784c0.384,0.096 0.7007,0.1952 0.9503,0.2976c0.2496,0.1024 0.464,0.2624 0.6432,0.48c0.1856,0.2112 0.2816,0.4928 0.2881,0.8448c0,0.3072 -0.0865,0.5824 -0.2593,0.8256c-0.1664,0.2432 -0.4095,0.4352 -0.7295,0.576c-0.3137,0.1344 -0.6817,0.2016 -1.104,0.2016zM48.2601,10.0864c-0.4352,0 -0.8256,-0.0768 -1.1712,-0.2304c-0.3456,-0.16 -0.6208,-0.3744 -0.8256,-0.6432c-0.1984,-0.2688 -0.3072,-0.5664 -0.3264,-0.8928h1.3536c0.0256,0.2048 0.1248,0.3744 0.2976,0.5088c0.1792,0.1344 0.4,0.2016 0.6624,0.2016c0.256,0 0.4544,-0.0512 0.5952,-0.1536c0.1472,-0.1024 0.2208,-0.2336 0.2208,-0.3936c0,-0.1728 -0.0896,-0.3008 -0.2688,-0.384c-0.1728,-0.0896 -0.4512,-0.1856 -0.8352,-0.288c-0.3968,-0.096 -0.7232,-0.1952 -0.9792,-0.2976c-0.2496,-0.1024 -0.4672,-0.2592 -0.6528,-0.4704c-0.1792,-0.2112 -0.2688,-0.496 -0.2688,-0.8544c0,-0.2944 0.0832,-0.5632 0.2496,-0.8064c0.1728,-0.2432 0.416,-0.4352 0.7296,-0.576c0.32,-0.1408 0.6944,-0.2112 1.1232,-0.2112c0.6336,0 1.1392,0.16 1.5168,0.48c0.3776,0.3136 0.5856,0.7392 0.624,1.2768h-1.2864c-0.0192,-0.2112 -0.1088,-0.3776 -0.2688,-0.4992c-0.1536,-0.128 -0.3616,-0.192 -0.624,-0.192c-0.2432,0 -0.432,0.0448 -0.5664,0.1344c-0.128,0.0896 -0.192,0.2144 -0.192,0.3744c0,0.1792 0.0896,0.3168 0.2688,0.4128c0.1792,0.0896 0.4576,0.1824 0.8352,0.2784c0.384,0.096 0.7008,0.1952 0.9504,0.2976c0.2496,0.1024 0.464,0.2624 0.6432,0.48c0.1856,0.2112 0.2816,0.4928 0.288,0.8448c0,0.3072 -0.0864,0.5824 -0.2592,0.8256c-0.1664,0.2432 -0.4096,0.4352 -0.7296,0.576c-0.3136,0.1344 -0.6816,0.2016 -1.104,0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lx54832659_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,328.7998,180.7773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lx54832659",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lx54832659_fill_path",
    d: "M12.3703,0h61.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-61.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6exy5lx54832659_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lx54832659_stroke_path",
    d: "M12.3703,0h61.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-61.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6exy5lx54832659_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lx54832659_stroke_path",
    d: "M12.3703,0h61.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-61.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(162, 197, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lx54832659_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -86.39999999999999,
    y: -25.340600000000002,
    width: 259.2,
    height: 76.02180000000001,
    fill: "url(#m6exy5lx54832659ps0)",
    mask: "url(#m6exy5lx54832659_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lx28465401_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lx28465401",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lx28465401_fill_path",
    d: "M3.28605,3.2992c0.704,0 1.3216,0.1376 1.8528,0.4128c0.5376,0.2752 0.9504,0.6688 1.2384,1.1808c0.2944,0.5056 0.4416,1.0944 0.4416,1.7664c0,0.672 -0.1472,1.2608 -0.4416,1.7664c-0.288,0.4992 -0.7008,0.8864 -1.2384,1.1616c-0.5312,0.2752 -1.1488,0.4128 -1.8528,0.4128h-2.3424v-6.7008zM3.23805,8.8576c0.704,0 1.248,-0.192 1.632,-0.576c0.384,-0.384 0.576,-0.9248 0.576,-1.6224c0,-0.6976 -0.192,-1.2416 -0.576,-1.632c-0.384,-0.3968 -0.928,-0.5952 -1.632,-0.5952h-0.9504v4.4256zM13.5561,10h-1.344l-3.0432,-4.5984v4.5984h-1.344v-6.7104h1.344l3.0432,4.608v-4.608h1.344zM17.1979,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM26.4778,10l-1.4784,-2.6112h-0.6336v2.6112h-1.344v-6.7008h2.5152c0.5184,0 0.96,0.0928 1.3248,0.2784c0.3648,0.1792 0.6368,0.4256 0.816,0.7392c0.1856,0.3072 0.2784,0.6528 0.2784,1.0368c0,0.4416 -0.128,0.8416 -0.384,1.2c-0.256,0.352 -0.6368,0.5952 -1.1424,0.7296l1.6032,2.7168zM24.3658,6.3808h1.1232c0.3648,0 0.6368,-0.0864 0.816,-0.2592c0.1792,-0.1792 0.2688,-0.4256 0.2688,-0.7392c0,-0.3072 -0.0896,-0.544 -0.2688,-0.7104c-0.1792,-0.1728 -0.4512,-0.2592 -0.816,-0.2592h-1.1232zM34.1158,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM32.7238,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM34.7512,7.3408c0,-0.5504 0.112,-1.0304 0.336,-1.44c0.224,-0.416 0.5344,-0.736 0.9312,-0.96c0.3968,-0.2304 0.8512,-0.3456 1.3632,-0.3456c0.6592,0 1.2032,0.1664 1.632,0.4992c0.4352,0.3264 0.7264,0.7872 0.8736,1.3824h-1.4496c-0.0768,-0.2304 -0.208,-0.4096 -0.3936,-0.5376c-0.1792,-0.1344 -0.4032,-0.2016 -0.672,-0.2016c-0.384,0 -0.688,0.1408 -0.912,0.4224c-0.224,0.2752 -0.336,0.6688 -0.336,1.1808c0,0.5056 0.112,0.8992 0.336,1.1808c0.224,0.2752 0.528,0.4128 0.912,0.4128c0.544,0 0.8992,-0.2432 1.0656,-0.7296h1.4496c-0.1472,0.576 -0.4384,1.0336 -0.8736,1.3728c-0.4352,0.3392 -0.9792,0.5088 -1.632,0.5088c-0.512,0 -0.9664,-0.112 -1.3632,-0.336c-0.3968,-0.2304 -0.7072,-0.5504 -0.9312,-0.96c-0.224,-0.416 -0.336,-0.8992 -0.336,-1.4496zM43.2334,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.392,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.416,0.224 -0.8832,0.336 -1.4016,0.336zM43.2334,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.3904,-0.3008 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.4032,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM48.3377,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM50.5293,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM54.7149,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lz17805471_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,87,134.7617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lz17805471",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lz17805471_fill_path",
    d: "M12.3703,0h69.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-69.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6exy5lz17805471_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lz17805471_stroke_path",
    d: "M12.3703,0h69.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-69.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6exy5lz17805471_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lz17805471_stroke_path",
    d: "M12.3703,0h69.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-69.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(162, 197, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5lz17805471_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -94.39999999999999,
    y: -25.340600000000002,
    width: 283.2,
    height: 76.02180000000001,
    fill: "url(#m6exy5lz17805471ps0)",
    mask: "url(#m6exy5lz17805471_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lz60694249_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5lz60694249",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5lz60694249_fill_path",
    d: "M3.25881,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM11.816,4.6816v5.3184h-1.3536v-0.672c-0.1728,0.2304 -0.4,0.4128 -0.68159,0.5472c-0.2752,0.128 -0.576,0.192 -0.9024,0.192c-0.416,0 -0.784,-0.0864 -1.104,-0.2592c-0.32,-0.1792 -0.5728,-0.4384 -0.7584,-0.7776c-0.1792,-0.3456 -0.2688,-0.7552 -0.2688,-1.2288v-3.12h1.344v2.928c0,0.4224 0.1056,0.7488 0.3168,0.9792c0.2112,0.224 0.4992,0.336 0.864,0.336c0.3712,0 0.6624,-0.112 0.87359,-0.336c0.2112,-0.2304 0.3168,-0.5568 0.3168,-0.9792v-2.928zM14.4861,5.4592c0.1728,-0.256 0.4096,-0.464 0.7104,-0.624c0.3072,-0.16 0.656,-0.24 1.0464,-0.24c0.4544,0 0.864,0.112 1.2288,0.336c0.3712,0.224 0.6624,0.544 0.8736,0.96c0.2176,0.4096 0.3264,0.8864 0.3264,1.4304c0,0.544 -0.1088,1.0272 -0.3264,1.4496c-0.2112,0.416 -0.5024,0.7392 -0.8736,0.9696c-0.3648,0.2304 -0.7744,0.3456 -1.2288,0.3456c-0.3968,0 -0.7456,-0.0768 -1.0464,-0.2304c-0.2944,-0.16 -0.5312,-0.3648 -0.7104,-0.6144v0.7584h-1.344v-7.104h1.344zM17.2989,7.3216c0,-0.32 -0.0672,-0.5952 -0.2016,-0.8256c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2112,-0.1216 -0.4416,-0.1824 -0.6912,-0.1824c-0.2432,0 -0.4736,0.064 -0.6912,0.192c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2368 -0.192,0.5152 -0.192,0.8352c0,0.32 0.064,0.5984 0.192,0.8352c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.1216 0.448,0.1824 0.6912,0.1824c0.2496,0 0.48,-0.064 0.6912,-0.192c0.2176,-0.128 0.3904,-0.3104 0.5184,-0.5472c0.1344,-0.2368 0.2016,-0.5184 0.2016,-0.8448zM21.5902,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM25.7758,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM30.8037,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.392,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.416,0.224 -0.8832,0.336 -1.4016,0.336zM30.8037,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.3904,-0.3008 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.4032,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM41.1688,4.6048c0.6528,0 1.1776,0.2016 1.5744,0.6048c0.4032,0.3968 0.6048,0.9536 0.6048,1.6704v3.12h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3648,0 -0.656,0.112 -0.8736,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3712,0 -0.6656,0.112 -0.8832,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-5.3184h1.344v0.6432c0.1728,-0.224 0.3936,-0.4 0.6624,-0.528c0.2752,-0.128 0.576,-0.192 0.9024,-0.192c0.416,0 0.7872,0.0896 1.1136,0.2688c0.3264,0.1728 0.5792,0.4224 0.7584,0.7488c0.1728,-0.3072 0.4224,-0.5536 0.7488,-0.7392c0.3328,-0.1856 0.6912,-0.2784 1.0752,-0.2784zM44.2777,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM48.4633,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM51.8112,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM52.4736,4.6816v5.3184h-1.344v-5.3184zM56.7487,4.6048c0.6336,0 1.1456,0.2016 1.536,0.6048c0.3904,0.3968 0.5856,0.9536 0.5856,1.6704v3.12h-1.344v-2.9376c0,-0.4224 -0.1056,-0.7456 -0.3168,-0.9696c-0.2112,-0.2304 -0.4992,-0.3456 -0.864,-0.3456c-0.3712,0 -0.6656,0.1152 -0.8832,0.3456c-0.2112,0.224 -0.3168,0.5472 -0.3168,0.9696v2.9376h-1.344v-5.3184h1.344v0.6624c0.1792,-0.2304 0.4064,-0.4096 0.6816,-0.5376c0.2816,-0.1344 0.5888,-0.2016 0.9216,-0.2016zM62.1835,10.0864c-0.4352,0 -0.8256,-0.0768 -1.1712,-0.2304c-0.3456,-0.16 -0.6208,-0.3744 -0.8256,-0.6432c-0.1984,-0.2688 -0.3072,-0.5664 -0.3264,-0.8928h1.3536c0.0256,0.2048 0.1248,0.3744 0.2976,0.5088c0.1792,0.1344 0.4,0.2016 0.6624,0.2016c0.256,0 0.4544,-0.0512 0.5952,-0.1536c0.1472,-0.1024 0.2208,-0.2336 0.2208,-0.3936c0,-0.1728 -0.0896,-0.3008 -0.2688,-0.384c-0.1728,-0.0896 -0.4512,-0.1856 -0.8352,-0.288c-0.3968,-0.096 -0.7232,-0.1952 -0.9792,-0.2976c-0.2496,-0.1024 -0.4672,-0.2592 -0.6528,-0.4704c-0.1792,-0.2112 -0.2688,-0.496 -0.2688,-0.8544c0,-0.2944 0.0832,-0.5632 0.2496,-0.8064c0.1728,-0.2432 0.416,-0.4352 0.7296,-0.576c0.32,-0.1408 0.6944,-0.2112 1.1232,-0.2112c0.6336,0 1.1392,0.16 1.5168,0.48c0.3776,0.3136 0.5856,0.7392 0.624,1.2768h-1.2864c-0.0192,-0.2112 -0.1088,-0.3776 -0.2688,-0.4992c-0.1536,-0.128 -0.3616,-0.192 -0.624,-0.192c-0.2432,0 -0.432,0.0448 -0.5664,0.1344c-0.128,0.0896 -0.192,0.2144 -0.192,0.3744c0,0.1792 0.0896,0.3168 0.2688,0.4128c0.1792,0.0896 0.4576,0.1824 0.8352,0.2784c0.384,0.096 0.7008,0.1952 0.9504,0.2976c0.2496,0.1024 0.464,0.2624 0.6432,0.48c0.1856,0.2112 0.2816,0.4928 0.288,0.8448c0,0.3072 -0.0864,0.5824 -0.2592,0.8256c-0.1664,0.2432 -0.4096,0.4352 -0.7296,0.576c-0.3136,0.1344 -0.6816,0.2016 -1.104,0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m105232628_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,261,132.9679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m105232628",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m105232628_fill_path",
    d: "M12.3703,0h43.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-43.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6exy5m105232628_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m105232628_stroke_path",
    d: "M12.3703,0h43.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-43.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6exy5m105232628_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m105232628_stroke_path",
    d: "M12.3703,0h43.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-43.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(162, 197, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5m105232628_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -68.39999999999999,
    y: -25.340600000000002,
    width: 205.2,
    height: 76.02180000000001,
    fill: "url(#m6exy5m105232628ps0)",
    mask: "url(#m6exy5m105232628_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m112850860_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m112850860",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m112850860_fill_path",
    d: "M3.21105,3.2992c0.704,0 1.3216,0.1376 1.8528,0.4128c0.5376,0.2752 0.9504,0.6688 1.2384,1.1808c0.2944,0.5056 0.4416,1.0944 0.4416,1.7664c0,0.672 -0.1472,1.2608 -0.4416,1.7664c-0.288,0.4992 -0.7008,0.8864 -1.2384,1.1616c-0.5312,0.2752 -1.1488,0.4128 -1.8528,0.4128h-2.3424v-6.7008zM3.16305,8.8576c0.704,0 1.248,-0.192 1.632,-0.576c0.384,-0.384 0.576,-0.9248 0.576,-1.6224c0,-0.6976 -0.192,-1.2416 -0.576,-1.632c-0.384,-0.3968 -0.928,-0.5952 -1.632,-0.5952h-0.9504v4.4256zM10.1115,10.0864c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4096,-0.2304 -0.7328,-0.5536 -0.9696,-0.9696c-0.2304,-0.416 -0.3456,-0.896 -0.3456,-1.44c0,-0.544 0.1184,-1.024 0.3552,-1.44c0.2432,-0.416 0.5728,-0.736 0.9888,-0.96c0.416,-0.2304 0.88,-0.3456 1.392,-0.3456c0.512,0 0.976,0.1152 1.392,0.3456c0.416,0.224 0.7424,0.544 0.9792,0.96c0.2432,0.416 0.3648,0.896 0.3648,1.44c0,0.544 -0.1248,1.024 -0.3744,1.44c-0.2432,0.416 -0.576,0.7392 -0.9984,0.9696c-0.416,0.224 -0.8832,0.336 -1.4016,0.336zM10.1115,8.9152c0.2432,0 0.4704,-0.0576 0.6816,-0.1728c0.2176,-0.1216 0.3904,-0.3008 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5248 0.192,-0.864c0,-0.5056 -0.1344,-0.8928 -0.4032,-1.1616c-0.2624,-0.2752 -0.5856,-0.4128 -0.9696,-0.4128c-0.384,0 -0.7072,0.1376 -0.9696,0.4128c-0.256,0.2688 -0.384,0.656 -0.384,1.1616c0,0.5056 0.1248,0.896 0.3744,1.1712c0.256,0.2688 0.576,0.4032 0.96,0.4032zM20.4766,4.6048c0.6528,0 1.1776,0.2016 1.5744,0.6048c0.4032,0.3968 0.6048,0.9536 0.6048,1.6704v3.12h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3648,0 -0.656,0.112 -0.8736,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-2.9376c0,-0.416 -0.1056,-0.7328 -0.3168,-0.9504c-0.2112,-0.224 -0.4992,-0.336 -0.864,-0.336c-0.3712,0 -0.6656,0.112 -0.8832,0.336c-0.2112,0.2176 -0.3168,0.5344 -0.3168,0.9504v2.9376h-1.344v-5.3184h1.344v0.6432c0.1728,-0.224 0.3936,-0.4 0.6624,-0.528c0.2752,-0.128 0.576,-0.192 0.9024,-0.192c0.416,0 0.7872,0.0896 1.1136,0.2688c0.3264,0.1728 0.5792,0.4224 0.7584,0.7488c0.1728,-0.3072 0.4224,-0.5536 0.7488,-0.7392c0.3328,-0.1856 0.6912,-0.2784 1.0752,-0.2784zM23.5856,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM27.7712,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM31.119,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1536,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0768,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.16,0.1472 0.24,0.3328 0.24,0.5568c0,0.224 -0.08,0.4128 -0.24,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM31.7814,4.6816v5.3184h-1.344v-5.3184zM36.0565,4.6048c0.6336,0 1.1456,0.2016 1.536,0.6048c0.3904,0.3968 0.5856,0.9536 0.5856,1.6704v3.12h-1.344v-2.9376c0,-0.4224 -0.1056,-0.7456 -0.3168,-0.9696c-0.2112,-0.2304 -0.4992,-0.3456 -0.864,-0.3456c-0.3712,0 -0.6656,0.1152 -0.8832,0.3456c-0.2112,0.224 -0.3168,0.5472 -0.3168,0.9696v2.9376h-1.344v-5.3184h1.344v0.6624c0.1792,-0.2304 0.4064,-0.4096 0.6816,-0.5376c0.2816,-0.1344 0.5888,-0.2016 0.9216,-0.2016z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m375384324_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,162.5996,15.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m375384324",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m375384324_fill_path",
    d: "M12.3703,0h78.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-78.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6exy5m375384324_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m375384324_stroke_path",
    d: "M12.3703,0h78.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-78.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6exy5m375384324_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m375384324_stroke_path",
    d: "M12.3703,0h78.0594c6.83193,0 12.3703,5.53837 12.3703,12.3703v0c0,6.83193 -5.53837,12.3703 -12.3703,12.3703h-78.0594c-6.83193,0 -12.3703,-5.53837 -12.3703,-12.3703v0c0,-6.83193 5.53837,-12.3703 12.3703,-12.3703z",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6exy5m375384324_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -103.39999999999999,
    y: -25.340600000000002,
    width: 310.2,
    height: 76.02180000000001,
    fill: "url(#m6exy5m375384324ps0)",
    mask: "url(#m6exy5m375384324_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m332982739_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6exy5m332982739",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6exy5m332982739_fill_path",
    d: "M6.99722,3.2992l-2.4576,6.7008h-1.632l-2.4576,-6.7008h1.44l1.8432,5.328l1.8336,-5.328zM7.45742,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.39678,0 0.74238,0.08 1.03678,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.04637,0.24c-0.448,0 -0.85761,-0.1152 -1.22881,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM11.643,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.24958,0 -0.47998,0.0608 -0.69118,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.12799,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.06401,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.69118,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM15.6533,2.896v7.104h-1.344v-7.104zM17.6628,4.048c-0.2368,0 -0.4352,-0.0736 -0.5952,-0.2208c-0.1537,-0.1536 -0.2304,-0.3424 -0.2304,-0.5664c0,-0.224 0.0767,-0.4096 0.2304,-0.5568c0.16,-0.1536 0.3584,-0.2304 0.5952,-0.2304c0.2368,0 0.432,0.0768 0.5856,0.2304c0.1599,0.1472 0.2399,0.3328 0.2399,0.5568c0,0.224 -0.08,0.4128 -0.2399,0.5664c-0.1536,0.1472 -0.3488,0.2208 -0.5856,0.2208zM18.3252,4.6816v5.3184h-1.3441v-5.3184zM19.3074,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM23.493,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM25.8137,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM29.9993,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM34.2303,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM41.3314,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM39.9394,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM41.9668,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM46.1524,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM50.7606,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM54.9462,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM57.2668,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM61.4524,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM65.6835,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM67.4949,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM71.6805,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))))))))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5le53578409_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 225.0611;0 225.0611;0 225.0611;0 225.0611;20.0549 205.0061;72.8886 152.1725;161.2418 63.8193;200.1707 24.8904;215.4124 9.6487;221.518 3.543;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283;222.8328 2.2283",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5le53578409_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-222.8328;-222.8328;-222.8328;-222.8328;-202.7778;-149.9442;-61.591;-22.6621;-7.4203;-1.3147;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lg42996160_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 123.3527;0 123.3527;0 123.3527;0 123.3527;0 123.3527;0 123.3527;29.1161 94.2365;112.5685 10.7842;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lg42996160_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-122.1314;-122.1314;-122.1314;-122.1314;-122.1314;-122.1314;-93.0152;-9.5629;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lg84208070_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 67.6016;0 67.6016;0 67.6016;0 67.6016;6.5326 61.069;55.2727 12.3289;66.3901 1.2115;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693;66.9323 0.6693",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lg84208070_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-66.9323;-66.9323;-66.9323;-66.9323;-60.3997;-11.6596;-0.5422;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lh74006792_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 38.0259;0 38.0259;0 38.0259;17.5597 20.4662;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765;37.6494 0.3765",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lh74006792_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-37.6494;-37.6494;-37.6494;-20.0897;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5li76896372_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 224.9585;0 224.9585;0 224.9585;0 224.9585;0 224.9585;17.5512 207.4072;94.2153 130.7432;187.8069 37.1516;214.1115 10.847;221.9739 2.9846;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273;222.7312 2.2273",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5li76896372_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-222.7312;-222.7312;-222.7312;-222.7312;-222.7312;-205.1799;-128.5159;-34.9242;-8.6197;-0.7573;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5li62600757_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 123.3527;0 123.3527;0 123.3527;0 123.3527;0 123.3527;0 123.3527;0 123.3527;51.7226 71.63;113.3501 10.0026;121.9604 1.3923;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213;122.1314 1.2213",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5li62600757_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-122.1314;-122.1314;-122.1314;-122.1314;-122.1314;-122.1314;-122.1314;-70.4087;-8.7812;-0.171;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate13 || (_animate13 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lj99536804",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.3;0.35;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate14 || (_animate14 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lk65753014",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.21;0.25;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate15 || (_animate15 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5ll85799611",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.33;0.37;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate16 || (_animate16 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5ll03534236",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.33;0.37;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate17 || (_animate17 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lm32914327",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.33;0.38;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate18 || (_animate18 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lm18604400",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.06;0.11;1",
    keySplines: "0.45 0.51 0.15 1;0.45 0.51 0.47 0.5;0.5 0.35 0.47 0.5",
    additive: "replace",
    fill: "freeze"
  })), _animate19 || (_animate19 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lq88522959",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.35;0.4;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate20 || (_animate20 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lv95816789",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.22;0.26;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate21 || (_animate21 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lx54832659",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.35;0.39;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate22 || (_animate22 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5lz17805471",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.33;0.37;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate23 || (_animate23 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6exy5m105232628",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.34;0.37;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationMotion);
export default __webpack_public_path__ + "static/media/Validation-motion.c2da1fd94060b8793891a2b60006d1e5.svg";
export { ForwardRef as ReactComponent };